/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { buildLocalizedUrl } from "./url.utils";

export interface AlternatesProps {
	canonical: string;
	languages: { [key: string]: string };
}

export const getAlternates = (locale: string, slug: string): AlternatesProps => {
	const languages: { [key: string]: string } = {};

	const { fullUrl } = buildLocalizedUrl(locale, slug);

	return {
		canonical: fullUrl,
		//languages purposely left empty MW-6406
		languages,
	};
};
